import { Component, OnInit, inject } from '@angular/core';
import { LoginComponent } from './login.component';
import { from, Observable, switchMap, tap } from 'rxjs';
import { ParamMap } from '@angular/router';
import { HttpResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { ParserService } from '@gallaghercp/core-frontend';
import { Angulartics2 } from 'angulartics2';

@Component({
    selector: 'core-token-entry',
    templateUrl: './login.component.html',
    standalone: false,
})
export class TokenEntryComponent extends LoginComponent implements OnInit {
    protected parser = inject(ParserService);
    protected angulartics = inject(Angulartics2);

    override ngOnInit() {
        this.titleService.setTitle('Authenticate - ' + this.appName);

        this.subscriptions.push(
            this.route.paramMap
                .pipe(
                    switchMap((params: ParamMap): Observable<HttpResponse<any>> => {
                        return this.api.post(
                            'token-auth',
                            {
                                tokens: [params.get('token1'), params.get('token2')],
                            },
                            { observe: 'response' },
                        );
                    }),
                    tap((response: HttpResponse<any>): void => {
                        if (response.headers.get('x-service-user-name')) {
                            this.parser.setCookie(
                                'x-service-user-name',
                                response.headers.get('x-service-user-name'),
                                '/',
                            );
                        }
                        if (response.headers.get('x-service-user-token')) {
                            this.parser.setCookie(
                                'x-service-user-token',
                                response.headers.get('x-service-user-token'),
                                '/',
                            );
                        }
                        if (response.headers.get('x-service-provider')) {
                            this.parser.setCookie(
                                'x-service-provider',
                                response.headers.get('x-service-provider'),
                                '/',
                            );
                        }
                    }),
                    switchMap(() => this.auth.initialise()),
                    tap(() => {
                        this.angulartics.eventTrack.next({
                            action: 'Auth succeeded',
                        });
                        return from(this.router.navigate(['/']));
                    }),
                    catchError(() => {
                        return from(this.router.navigate(['/login']));
                    }),
                )
                .subscribe(),
        );
    }
}
